import script from "./Detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./Detail.vue?vue&type=script&lang=ts&setup=true"

import "./Detail.vue?vue&type=style&index=0&id=4e3f00a6&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e3f00a6"]])

export default __exports__